export const theme = {
  addressTextTransform: Styles.textTransform.headlines,
  directionsLinkStyledColor: Styles.color.grey.one,
};
